import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTracking } from "react-tracking";
import { apiPostNewOrderDate } from "Root/api/apiProfile";
import { setGlobalLoading, setPreviousCadence, updateNextBillDate, } from "Root/profile/redux/actionCreators/makeActionCreator";
import { LoadFutureOrdersThunk } from "Root/profile/redux/thunkCreators/orders/futureOrders";
import { LoadNextOrderDatesThunk, UpdateCadenceThunk } from "Root/profile/redux/thunkCreators/orders/nextOrderDates";
import toastService from "Root/profile/toastService";
import { EditProduct, ManageDelivery } from "Root/profile/utils/trackingEnums";
import { useHistory } from "react-router";
import { useScreenWidth } from "../hooks";
import { prepareDateToPost, getDateForCalendar, getSnoozeOrderDate, planTypeValues, cadenceValues, skipOrderValues, } from "../utils";
import { subscriptionText } from "../constants";
import { LoadOrderStatusDataThunk } from "Root/profile/redux/thunkCreators/orders/orderDetails";
const useSnoozeModifyOrder = (fromSkipOrder, toggleDrawer, needsToProvidePauseReason, isSnooze, isModify, isSkip, isPlanType, isDeliveryCadence) => {
    const [payload, setPayload] = useState({
        new_date: "",
        reason: "",
        plan: "standard",
        cadence: 4,
        method: "",
    });
    const ordersDates = useSelector((state) => state.ordersInfo.nextOrderDates);
    const planCadence = useSelector((state) => state.ordersInfo.nextOrderDates.planCadence);
    const { plan } = useSelector((state) => state.ordersInfo.nextOrderDates);
    const previousCadence = useSelector((state) => state.ordersInfo.nextOrderDates.previousCadence);
    const history = useHistory();
    const screenWidth = useScreenWidth();
    const changeDate = (date) => {
        setPayload({ ...payload, new_date: prepareDateToPost(date) });
    };
    const needToAskForReason = () => {
        return needsToProvidePauseReason;
    };
    const isDateMovedEarlier = () => {
        const date_arr = payload.new_date.split(",");
        const newDate = new Date(parseInt(date_arr[0], 10), parseInt(date_arr[1], 10), parseInt(date_arr[2], 10));
        const oldDate = new Date(ordersDates.nextShipmentYear, ordersDates.nextShipmentMonth, ordersDates.nextShipmentDay);
        return newDate < oldDate;
    };
    const askForReasonStep = () => {
        if (isDeliveryCadence) {
            return false;
        }
        if (isDateMovedEarlier()) {
            return false;
        }
        return needToAskForReason() && payload.reason == "";
    };
    const string_to_date = () => {
        const date_arr = payload.new_date.split(",");
        return new Date(parseInt(date_arr[0], 10), parseInt(date_arr[1], 10), parseInt(date_arr[2], 10));
    };
    const isDateIsToday = () => {
        const newDate = string_to_date();
        const today = new Date();
        return (newDate.getDate() === today.getDate() &&
            newDate.getMonth() === today.getMonth() &&
            newDate.getFullYear() === today.getFullYear());
    };
    const areDatesEqual = (date1, date2) => {
        return (date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate());
    };
    const isMobile = screenWidth < 768;
    const { maxDate, minDate } = getDateForCalendar({
        day: ordersDates.nextShipmentDay,
        year: ordersDates.nextShipmentYear,
        month: ordersDates.nextShipmentMonth,
    });
    const dispatch = useDispatch();
    const [selectedDeliveryState, setSelectedDeliveryState] = useState("");
    const { nextBillDate } = useSelector((state) => state.ordersInfo.nextOrderDates);
    const { trackEvent } = useTracking();
    const trackSaveDeliveryFrequency = (weeks) => {
        const cadence = previousCadence || 4;
        trackEvent({
            funComponent: EditProduct.EditOrderDate,
            event: `${ManageDelivery.Save_deliveryFrequency}__weeks_changed=${weeks - cadence}`,
        });
    };
    const trackSaveNextOrderDate = (days) => {
        if (isSnooze) {
            trackEvent({
                funComponent: EditProduct.EditOrderDate,
                event: `${ManageDelivery.Snooze_order}__snooze_weeks=${selectedDeliveryState}`,
            });
        }
        else if (isModify) {
            trackEvent({
                funComponent: EditProduct.EditOrderDate,
                event: `${ManageDelivery.Save_nextOrderDate}__days_changed=${days}`,
            });
        }
    };
    const [editDeliveryState, setEditDeliveryState] = useState({
        snooze: false,
        skip: false,
        changeDate: false,
        plan_type: false,
        cadence: false,
        method: "",
    });
    const setInitialValues = () => {
        if (isSnooze) {
            setEditDeliveryState({ ...editDeliveryState, snooze: true, method: "snooze" });
            setPayload({ ...payload, method: "snooze" });
        }
        if (isSkip) {
            setEditDeliveryState({ ...editDeliveryState, skip: true, method: "skip" });
            setPayload({ ...payload, method: "skip" });
        }
        if (isModify) {
            setEditDeliveryState({ ...editDeliveryState, changeDate: true, method: "calendar" });
            setPayload({ ...payload, method: "calendar" });
        }
        if (isPlanType) {
            setEditDeliveryState({ ...editDeliveryState, plan_type: true, method: "plan" });
            setPayload({
                ...payload,
                plan,
            });
        }
        if (isDeliveryCadence) {
            setEditDeliveryState({ ...editDeliveryState, cadence: true, method: "cadence" });
            setPayload({
                ...payload,
                cadence: planCadence,
            });
        }
    };
    useEffect(() => {
        setInitialValues();
    }, []);
    useEffect(() => {
        if (fromSkipOrder > 0) {
            // if (fromSkipOrder === 4) {
            //   setEditDeliveryState({ ...editDeliveryState, skip: true });
            // } else {
            setEditDeliveryState({ ...editDeliveryState, snooze: true });
            setSelectedDeliveryState(fromSkipOrder.toString());
            setPayload({
                ...payload,
                new_date: prepareDateToPost(getSnoozeOrderDate(fromSkipOrder, {
                    day: ordersDates.nextShipmentDay,
                    month: ordersDates.nextShipmentMonth,
                    year: ordersDates.nextShipmentYear,
                })),
            });
            //  }
        }
    }, [fromSkipOrder]);
    const clearEditDeliveryState = (includingMethod = true) => setEditDeliveryState({
        snooze: false,
        skip: false,
        changeDate: false,
        plan_type: false,
        cadence: false,
        method: includingMethod ? "" : editDeliveryState.method,
    });
    const getTitleText = () => {
        if (editDeliveryState.changeDate) {
            return {
                title: subscriptionText.modify_order,
                subTitle: () => isDateIsToday()
                    ? `You will be charged today and your order will arrive within 4-7 business days. Future orders will be shipped every ${payload.cadence} weeks.`
                    : subscriptionText.modify_order_note,
            };
        }
        if (editDeliveryState.snooze) {
            return {
                title: subscriptionText.snooze_order,
                subTitle: () => subscriptionText.snooze_order_note,
            };
        }
        if (editDeliveryState.plan_type) {
            return {
                title: subscriptionText.plan_type,
                subTitle: () => subscriptionText.plan_type_subtitle,
            };
        }
        if (editDeliveryState.cadence) {
            return {
                title: subscriptionText.modify_delivery_cadence,
                subTitle: () => subscriptionText.modify_delivery_cadence_subtitle,
            };
        }
        if (editDeliveryState.skip) {
            return {
                title: subscriptionText.skip_delivery,
                subTitle: () => subscriptionText.skip_delivery_note(string_to_date().toLocaleDateString()),
            };
        }
        return {
            title: "",
            subTitle: () => "",
        };
    };
    const calculateNextOrderDate = (planType) => {
        if (planType === planCadence) {
            return nextBillDate;
        }
        const weekInMilliseconds = 7 * 24 * 60 * 60 * 1000;
        const day = 24 * 60 * 60 * 1000;
        const nextBillDateMl = (planType - planCadence) * weekInMilliseconds + new Date(nextBillDate).getTime();
        const date = new Date(nextBillDateMl + 1 * day);
        if (date.getTime() - new Date().getTime() < 0) {
            return `${nextBillDate}`;
        }
        return `${date.toLocaleDateString("en-US")}`;
    };
    const cadenceOptions = [...cadenceValues].map((item) => ({
        ...item,
        onClick: () => {
            setPayload({
                ...payload,
                cadence: Number(item.value),
            });
        },
        subLabel: `Next Order: ${calculateNextOrderDate(item.value)}`,
        selected: item.value === payload.cadence,
    }));
    const planTypeOptions = [...planTypeValues].map((item) => ({
        ...item,
        onClick: () => {
            setPayload({
                ...payload,
                plan: item.value,
            });
        },
        selected: item.value === payload.plan,
    }));
    const snoozeOrderOptions = [
        ...[1, 2, 3, 4].map((item) => ({
            // 1,2,3 - number of weeks
            label: `${item} Week${item > 1 ? "s" : ""}`,
            subLabel: `${getSnoozeOrderDate(item, {
                day: ordersDates.nextShipmentDay,
                month: ordersDates.nextShipmentMonth,
                year: ordersDates.nextShipmentYear,
            }).toLocaleDateString()} billing date`,
            onClick: () => {
                setSelectedDeliveryState(item.toString());
                setPayload({
                    ...payload,
                    new_date: prepareDateToPost(getSnoozeOrderDate(item, {
                        day: ordersDates.nextShipmentDay,
                        month: ordersDates.nextShipmentMonth,
                        year: ordersDates.nextShipmentYear,
                    })),
                });
            },
            selected: selectedDeliveryState === item.toString(),
        })),
    ];
    const skipOrderOptions = [
        ...skipOrderValues.map((item) => ({
            label: item.label,
            onClick: () => {
                setSelectedDeliveryState(item.label);
                setPayload({
                    ...payload,
                    reason: item.value,
                    method: editDeliveryState.method,
                });
            },
            selected: selectedDeliveryState === item.label,
        })),
    ];
    const isSameDate = () => {
        const date_arr = payload.new_date.split(",");
        const newDate = new Date(parseInt(date_arr[0], 10), parseInt(date_arr[1], 10), parseInt(date_arr[2], 10));
        const oldDate = new Date(ordersDates.nextShipmentYear, ordersDates.nextShipmentMonth, ordersDates.nextShipmentDay);
        return areDatesEqual(newDate, oldDate);
    };
    const disabledButton = () => {
        if (editDeliveryState.changeDate) {
            if (!payload.new_date || isSameDate()) {
                return true;
            }
            return false;
        }
        if (editDeliveryState.snooze) {
            if (!payload.new_date) {
                return true;
            }
            return false;
        }
        if (editDeliveryState.plan_type) {
            if (!payload.plan) {
                return true;
            }
            if (payload.plan === plan) {
                return true;
            }
            return false;
        }
        if (editDeliveryState.cadence) {
            if (!payload.cadence) {
                return true;
            }
            if (payload.cadence === planCadence) {
                return true;
            }
            return false;
        }
        if (!payload.new_date || !payload.reason || !payload) {
            return true;
        }
        return false;
    };
    const getOptions = () => {
        if (editDeliveryState.skip) {
            return skipOrderOptions;
        }
        if (editDeliveryState.plan_type) {
            return planTypeOptions;
        }
        if (editDeliveryState.cadence) {
            return cadenceOptions;
        }
        if (editDeliveryState.snooze) {
            return snoozeOrderOptions;
        }
        return [];
    };
    const confirmPlan = async () => {
        toggleDrawer();
        dispatch(setGlobalLoading(true));
        if (payload.plan === "advantage" && planCadence) {
            dispatch(setPreviousCadence(planCadence));
        }
        const weeks = payload.plan === "standard" ? previousCadence || 4 : 12;
        await dispatch(UpdateCadenceThunk(weeks, payload.plan));
        await dispatch(LoadFutureOrdersThunk());
        clearEditDeliveryState();
        dispatch(setGlobalLoading(false));
    };
    const confirmDelivery = async () => {
        toggleDrawer();
        await dispatch(UpdateCadenceThunk(payload.cadence));
        await dispatch(LoadFutureOrdersThunk());
        trackSaveDeliveryFrequency(payload.cadence);
        clearEditDeliveryState();
        dispatch(setGlobalLoading(false));
    };
    const onConfirmChanges = () => {
        if (askForReasonStep()) {
            setEditDeliveryState({ ...editDeliveryState, skip: true, changeDate: false });
            return;
        }
        const date_arr = payload.new_date.split(",");
        const newDate = new Date(parseInt(date_arr[0], 10), parseInt(date_arr[1], 10), parseInt(date_arr[2], 10));
        const oldDate = new Date(ordersDates.nextShipmentYear, ordersDates.nextShipmentMonth, ordersDates.nextShipmentDay);
        if (isDateIsToday()) {
            history.push("/app/reactivation/confirm#now", { prevPath: "/app/subscription#modify" });
            return;
        }
        if (editDeliveryState.plan_type) {
            toggleDrawer();
            dispatch(setGlobalLoading(true));
            confirmPlan();
            return;
        }
        if (editDeliveryState.cadence) {
            toggleDrawer();
            dispatch(setGlobalLoading(true));
            confirmDelivery();
            return;
        }
        if (payload.new_date) {
            // setGlobalLoading(true);
            dispatch(setGlobalLoading(true));
            toggleDrawer();
            apiPostNewOrderDate(payload)
                .then(() => {
                dispatch(LoadNextOrderDatesThunk());
                dispatch(updateNextBillDate(nextBillDate));
                dispatch(LoadNextOrderDatesThunk());
                dispatch(LoadFutureOrdersThunk());
                dispatch(LoadOrderStatusDataThunk());
                toastService.successMessage("Order date successfully updated");
                clearEditDeliveryState();
                const diff = newDate.getTime() - oldDate.getTime();
                const diffInDays = diff / (1000 * 3600 * 24);
                trackSaveNextOrderDate(diffInDays);
            })
                .catch(() => toastService.errorMessage("Something went wrong"))
                .finally(() => 
            // setGlobalLoading(false);
            dispatch(setGlobalLoading(false)));
        }
    };
    const getBtnLabel = () => {
        if (isDateIsToday()) {
            return "PROCEED TO PAYMENT";
        }
        else if (askForReasonStep()) {
            return "CONTINUE";
        }
        return "SAVE CHANGES";
    };
    return {
        maxDate,
        minDate,
        toggleDrawer,
        isMobile,
        ordersDates,
        payload,
        changeDate,
        setPayload,
        onConfirmChanges,
        getOptions,
        disabledButton,
        getTitleText,
        editDeliveryState,
        clearEditDeliveryState,
        setInitialValues,
        getBtnLabel,
    };
};
export default useSnoozeModifyOrder;
